import qs from 'qs';

export function buildQueryFromObject(prefix: string, object: Record<string, any>): string {
  return prefix + qs.stringify(object);
}
